import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {useApi} from '../hooks/useApi'
import {RootState} from './rootReducer'
import {AuthContextInterface} from '../components/AuthProvider'
import {LoadingStatuses} from '../components/types/LoadingStatusses'

//#region types
export type WorkshopReplay = {
  id: string
  workshopReplayGroupId: string
  workshopId: string
  videoId: string
  brightcoveId: string
  videoDuration: number
  title: string
  description: string
  date: string
  prerequisites: string
  coach: string
  lessonPlanId: string
  abbr: string
}

export type WorkshopReplayGroup = {
  startDate: string
  endDate: string
  replays: WorkshopReplay[]
}

type SliceState = {
  workshopReplay?: WorkshopReplay
  workshopReplayGroup?: WorkshopReplayGroup
  status: LoadingStatuses
  error?: string | null | undefined
}

//#region api
type GetWorkshopsReplayPayload = {
  auth: AuthContextInterface
  workshopReplayId: string
}

export const getWorkshopReplay = createAsyncThunk<
  any,
  GetWorkshopsReplayPayload
>('/workshop/replay/get', async ({auth, workshopReplayId}) => {
  const endpoint = `/v1/are/workshop-replays/${workshopReplayId}`

  return useApi(auth, endpoint, {
    method: 'GET',
  }).then(res => res.json())
})

export const clearReplayState = createAsyncThunk<any>('clerReplay/get', () => {
  return ''
})
//#endregion

//#region slice
const initialState: SliceState = {
  workshopReplay: undefined,
  workshopReplayGroup: undefined,
  status: LoadingStatuses.Idle,
  error: undefined,
}

export default createSlice({
  name: 'workshopReplay',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getWorkshopReplay.fulfilled, (state, action) => {
      state.workshopReplay = action.payload.replay
      state.workshopReplayGroup = action.payload.group
      state.status = LoadingStatuses.Succeeded
      state.error = undefined
    })
    builder.addCase(getWorkshopReplay.pending, state => {
      state.workshopReplay = undefined
      state.workshopReplayGroup = undefined
      state.status = LoadingStatuses.Loading
    })
    builder.addCase(getWorkshopReplay.rejected, (state, action) => {
      state.workshopReplay = undefined
      state.workshopReplayGroup = undefined
      state.status = LoadingStatuses.Failed
      state.error = action.error.message
    })
    builder.addCase(clearReplayState.fulfilled, state => {
      state.workshopReplay = undefined
      state.status = LoadingStatuses.Idle
    })
  },
})
//#endregion

//#region selectors
export const selectWorkshopReplay = ({workshopReplay}: RootState) =>
  workshopReplay.workshopReplay
export const selectWorkshopReplayGroup = ({workshopReplay}: RootState) =>
  workshopReplay.workshopReplayGroup
export const selectWorkshopReplayStatus = ({workshopReplay}: RootState) =>
  workshopReplay.status
//#endregion
